import { render, staticRenderFns } from "./ElectMayor.vue?vue&type=template&id=37deb058&"
import script from "./ElectMayor.vue?vue&type=script&lang=js&"
export * from "./ElectMayor.vue?vue&type=script&lang=js&"
import style0 from "./ElectMayor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports